import api from './api';

const serviceReminderService = {
  create: async (payload) => {
    const response = await api.post('/service-reminders', payload, { validateStatus: () => true });
    return response.data;
  },

  getAll: async () => {
    const response = await api.get('/service-reminders', { validateStatus: () => true });
    return response.data;
  },

  update: async (id, payload) => {
    const response = await api.put(`/service-reminders/${id}`, payload, { validateStatus: () => true });
    return response.data;
  },
};

export { serviceReminderService };


